<div class="panel-heading" role="tab" id="heading_surveys">
  <div class="row">
    <div class="col-md-6">
      <h4 class="panel-title">
        <a role="button" id="collapse_surveys" data-toggle="collapse" data-parent="#accordion" href="#panel_surveys" aria-expanded="true" aria-controls="collapse_surveys">
          Surveys
        </a>
      </h4>
    </div>
  </div>
</div>
<div id="panel_surveys" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="heading_surveys">
  <div class="panel-body">
    <table class="table table-bordered table-striped table-condensed">
      <tr>
        <th>Survey Slug</th>
        <th>Complete</th>
        <th></th>
      </tr>
      {{#each surveys}}
        <tr>
          <td>{{slug}}</td>
          <td>{{#if progress}}true{{else}}false{{/if}}</td>
          <td>
            {{#if progress}}
              <button class="btn btn-xs btn-survey btn-danger" data-survey="{{slug}}">Remove</button>
            {{else}}
              <button class="btn btn-xs btn-survey btn-success" data-survey="{{slug}}">Add</button>
            {{/if}}
          </td>
        </tr>
      {{/each}}
    </table>
  </div>
</div>
